import React, { ReactNode } from 'react';
import { IoSearch } from 'react-icons/io5';
import styles from './search.module.scss';

interface IButton {
  placeholder?: string;
  icon?: ReactNode;
  ending?: ReactNode;
  value?: string;
  required?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<any>) => void;
}

const CSearchBar = (props: IButton) => {
  return (
    <section className={styles.section}>
      <input
        type='text'
        className={styles.search}
        placeholder={'caută…'}
        {...props}
      />
      <span>{<IoSearch />}</span>
    </section>
  );
};

export default CSearchBar;
